import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { RoutePermissions, defaultRoutes, routes } from '../../routes';
import { useSelector } from 'react-redux';
import { selectAuth } from '../../features/authSlice';
import { JSX } from 'react';
import RouterInitializer from './RouterInitializer';

export const Routing = (): JSX.Element => {
    const user = useSelector(selectAuth);
    const userRole = user?.role ?? '';
    const filterRoutes: any[] = userRole
        ? routes.filter((item) =>
              RoutePermissions[userRole]?.includes(item.name),
          )
        : defaultRoutes;
    return (
        <BrowserRouter>
            <RouterInitializer />
            <Routes>
                {filterRoutes.map(({ path, element: Component }) => (
                    <Route key={path} path={path} element={<Component />} />
                ))}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    );
};
